import "./App.css";
import React, { Suspense, useContext, useState } from "react";
import { BrowserRouter } from "react-router-dom";

//assets
//import logoNovis from "../assets/img/logo_novis.png";
//import logoVigi from "../assets/img/logo_vigilado_vertical.png";
import logoVigiNovi from "../assets/img/logo_vigilado_novis_horizontal.png";
import LogoVigiNoviVert from "../assets/img/logo_vigilado_novis_vertical.png"

//routers
import { AppRouter } from "./routers/AppRouter";

//layouts
import { MobileContainer } from "../shared/layouts/MobileContainer";

//Data Display
import { LoadingAlert } from "../shared/data_display/LoadingAlert";

//context
//import { GlobalVars } from "../contexts/GlobalVars";

export default function App() {
  //const globalVars = useContext(GlobalVars)
  document.title = "Araucaria-MQ";
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {loaded === false && <LoadingAlert />}

      <Suspense fallback={<LoadingAlert />}>
        <BrowserRouter>
          <MobileContainer>
            {/*
            <img src={logoNovis}  
            style={{position:"fixed", right:"20px", zIndex:"var(--alert-layer1-zindex)",
              width:"100px"
            }}/>    
            */}  
            <img src={LogoVigiNoviVert}  
            style={{position:"fixed", right:"120px", zIndex:"var(--alert-layer1-zindex)",
              bottom:"20px", width:"auto", height:"220px", backgroundColor:"rgba(255,255,255, 0.4)"
            }}/>
           {/* <GlobalVars.Provider value={globalVars}>*/}
              <AppRouter
                onStartLoadingPage={() => {
                  console.log("----StartLoading");
                  setLoaded(false);
                }}
                onLoad={() => {
                  console.log("----Loaded");
                  setLoaded(true);
                }}
              />
           {/* </GlobalVars.Provider>*/}
          </MobileContainer>
        </BrowserRouter>
      </Suspense>
    </>
  );
}

//export default App;
